import axiosInstance from '@/store/axios'
import { rejectError } from '@/store/helper'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    scOperators ({ commit }, params) {
      return axiosInstance.get('/api/v1/sc-operators', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    scOperator ({ commit }, params) {
      return axiosInstance.get(`/api/v1/sc-operators/${params.id}`, { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    scanOperator ({ dispatch }, operator) {
      return axiosInstance({
        method: 'POST',
        url: `/api/v1/sc-operators/${operator.id}/scan`,
        data: operator,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    patchOperatorAsset ({ dispatch }, data) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/sc-operators/${data.id}/channel/${data.asset_id}`,
        data: data,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    getOperatorAssets ({ dispatch }, operator) {
      return axiosInstance({
        method: 'GET',
        url: `/api/v1/sc-operators/${operator.id}/assets`,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    operatorsStat ({ commit }, params) {
      return axiosInstance.get('/api/v1/sc-operators/stat', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    addChannelToSC ({ commit }, params) {
      return axiosInstance.get(`/api/v1/sc-operators/${params.id}/add-channel`, { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
  },
}
